import React, { useEffect, useState, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { FiCheckCircle, FiInfo, FiX } from "react-icons/fi";
import { dismissNotification, getNotifications, subscribeNotifications } from "../lib/notifications";
import "./NotificationCenter.css";

function Notice({ notice }) {
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return undefined;
    const timer = setTimeout(() => dismissNotification(notice.id), 6000);
    return () => clearTimeout(timer);
  }, [notice.id, paused]);

  const Icon = notice.tone === "info" ? FiInfo : FiCheckCircle;
  return (
    <div
      className={`binder-notice binder-notice--${notice.tone}`}
      role="status"
      aria-atomic="true"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocusCapture={() => setPaused(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setPaused(false);
      }}
    >
      <Icon className="binder-notice__icon" aria-hidden="true" />
      <span className="binder-notice__message">{notice.message}</span>
      <button className="binder-notice__close" type="button" aria-label="Cerrar aviso" onClick={() => dismissNotification(notice.id)}>
        <FiX aria-hidden="true" />
      </button>
    </div>
  );
}

export default function NotificationCenter() {
  const notices = useSyncExternalStore(subscribeNotifications, getNotifications, getNotifications);
  return createPortal(
    <div className="binder-notices" aria-label="Avisos del sistema">
      {notices.map((notice) => <Notice key={notice.id} notice={notice} />)}
    </div>,
    document.body
  );
}
